export const THEMES = {
  LIGHT: "LIGHT",
  DARK: "DARK",
  NATURE: "NATURE",
};

export const MAIN_MARKET_DOMAIN_NAME = "https://market.flyingmilktea.com";
